import React, { Component } from 'react';
import { Loader } from 'react-feather';
import InputDualList from './InputDualList';
import { fetchGet } from '../../cruds/remote';
import './RemoteInputDualList.css';

class RemoteInputDualList extends Component {
  constructor(props) {
    super(props);
    this.state = { options: [] };

    setTimeout(() => {
        if (this.state.isLoading === undefined) {
          this.setState({ isLoading: true });
        }
      }, 600);

  }

  componentDidMount = () => {
    fetchGet(this.props.from)
      .then(data =>  this.setState({ options: data, isLoading: false }));
  };

  render() {
    const { optionLabelName, value } = this.props;
    const options = this.state.options.map(o => ({ value: String(o.id), label: o[optionLabelName] }));
    const { isLoading } = this.state;

    return (
      <div className="RemoteInputDualList">
        {isLoading ? <div className="loading"><Loader size={30} /></div> : ''}
        <InputDualList {...this.props} value={value ? value : []} options={options} />
      </div>
    );
  }

}

export default RemoteInputDualList;



// WEBPACK FOOTER //
// ./src/main/components/input/RemoteInputDualList.js